import React from "react";
import { ImageIcon } from "lucide-react";

/**
 * ImagePlaceholder – ersetzt schwere Fotos.
 * Zeigt einen eleganten, architektonischen Platzhalter mit "Hier Bild einfügen" Label.
 */
export default function ImagePlaceholder({ label = "Hier Bild einfügen", className = "" }) {
    return (
        <div
            className={`relative w-full h-full flex items-center justify-center bg-[#F5F5F5] ${className}`}
            style={{
                backgroundImage:
                    "linear-gradient(rgba(20,16,13,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(20,16,13,0.05) 1px, transparent 1px)",
                backgroundSize: "32px 32px",
            }}
            aria-label={label}
        >
            {/* Diagonal cross marker */}
            <svg
                className="absolute inset-0 w-full h-full text-[#14100D]/8"
                preserveAspectRatio="none"
                viewBox="0 0 100 100"
                fill="none"
                stroke="currentColor"
                strokeWidth="0.15"
            >
                <line x1="0" y1="0" x2="100" y2="100" />
                <line x1="100" y1="0" x2="0" y2="100" />
                <rect x="0" y="0" width="100" height="100" />
            </svg>

            <div className="relative z-[1] flex flex-col items-center gap-3 text-center px-6">
                <ImageIcon size={22} className="text-[#E20514]" strokeWidth={1.2} />
                <div className="text-[10px] tracking-[0.32em] uppercase text-[#14100D]/60 font-medium">
                    {label}
                </div>
            </div>
        </div>
    );
}
